"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _Styles = require("../utils/Styles");

var _UIDialogButton = _interopRequireDefault(require("../dialog/UIDialogButton"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 2;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: inherit;\n  display: block;\n  flex-grow: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  width: ", ";\n  height: ", ";\n  color: ", ";\n\n  &::after {\n    padding: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SIZE_OPTIONS = {
  small: {
    size: _sizes.SMALL_CLOSE_BUTTON_SIZE,
    padding: 12
  },
  medium: {
    size: _sizes.MEDIUM_CLOSE_BUTTON_SIZE,
    padding: 16
  },
  large: {
    size: _sizes.MODAL_CLOSE_BUTTON_SIZE,
    padding: 20
  },
  'extra-large': {
    size: _sizes.EXTRA_LARGE_CLOSE_BUTTON_SIZE,
    padding: 38
  }
};
var CloseButton = (0, _styledComponents.default)(_UIDialogButton.default).withConfig({
  displayName: "UICloseButton__CloseButton",
  componentId: "r1ump1-0"
})(_templateObject(), _sizes.MODAL_CLOSE_BUTTON_OFFSET, _sizes.MODAL_CLOSE_BUTTON_OFFSET, function (_ref) {
  var size = _ref.size;
  return (0, _Styles.toPx)(size);
}, function (_ref2) {
  var size = _ref2.size;
  return (0, _Styles.toPx)(size);
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var padding = _ref4.padding;
  return (0, _Styles.toPx)(padding);
});

var CloseIcon = _styledComponents.default.svg.withConfig({
  displayName: "UICloseButton__CloseIcon",
  componentId: "r1ump1-1"
})(_templateObject2());

var CloseIconInner = _styledComponents.default.path.withConfig({
  displayName: "UICloseButton__CloseIconInner",
  componentId: "r1ump1-2"
})(_templateObject3());

var renderCloseIcon = (0, _memoize.default)(function () {
  return _react.default.createElement(CloseIcon, {
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement(CloseIconInner, {
    d: "M14.5,1.5l-13,13m0-13,13,13",
    transform: "translate(-1 -1)"
  }));
});

var UICloseButton = function UICloseButton(_ref5) {
  var className = _ref5.className,
      disabled = _ref5.disabled,
      size = _ref5.size,
      rest = (0, _objectWithoutProperties2.default)(_ref5, ["className", "disabled", "size"]);
  var sizeOptions = SIZE_OPTIONS[(0, _tshirtSize.toLonghandSize)(size)];
  return _react.default.createElement(CloseButton, (0, _extends2.default)({}, rest, {
    "aria-label": _I18n.default.text('salesUI.UICloseButton.label'),
    className: (0, _classnames.default)('private-close__button', className),
    "data-action": "close",
    disabled: disabled,
    IconHolder: renderCloseIcon,
    padding: sizeOptions.padding,
    size: sizeOptions.size
  }));
};

UICloseButton.propTypes = {
  color: _propTypes.default.string,
  disabled: _propTypes.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['sm', 'md', 'lg', 'xl'])
};
UICloseButton.defaultProps = {
  disabled: false,
  size: 'large'
};
UICloseButton.displayName = 'UICloseButton';
var _default = UICloseButton;
exports.default = _default;
module.exports = exports.default;